export default __webpack_public_path__ + "static/media/h2a2.6cc504c6.jpg";